import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  useEffect(() => {
    // ======= Sticky Navbar Scroll Effect =======
    const navbar = document.querySelector(".custom-navbar");

    const handleScroll = () => {
      if (window.scrollY > 10) {
        navbar?.classList.add("scrolled");
      } else {
        navbar?.classList.remove("scrolled");
      }
    };

    // Check initial scroll position
    handleScroll();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const handleServicesClick = (e) => {
    e.preventDefault();
    const scrollToServices = () => {
      const servicesSection = document.getElementById("services");
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: "smooth" });
      }
    };

    if (location.pathname === "/") {
      scrollToServices();
    } else {
      navigate("/", { state: { targetId: "services" } });
    }

    // Close mobile menu if open
    const mobileMenu = document.getElementById("mobileMenu");
    const overlay = document.getElementById("menuOverlay");
    if (mobileMenu?.classList.contains("open")) {
      mobileMenu.classList.remove("open");
      overlay?.classList.remove("active");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container">
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <span className="logo-circles">
            <span className="circle circle-h">H</span>
            <span className="circle circle-w">W</span>
            <span className="circle circle-s">S</span>
          </span>
        </Link>
        <button className="navbar-toggler" type="button" id="mobileMenuBtn">
          <span className="navbar-toggler-icon menu-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link to="/about" className="nav-link">
                About
              </Link>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link" onClick={handleServicesClick}>
                Our Services
              </a>
              <ul className="sub-menu">
                <li className="sub-item">
                  <Link to="/web-development" className="nav-link">
                    Web Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/mobile-app-development" className="nav-link">
                    Mobile App Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/ui-ux" className="nav-link">
                    UI/UX Design
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/api-development" className="nav-link">
                    API Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/e-commerce-development" className="nav-link">
                    E-Commerce Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/crm-development" className="nav-link">
                    CRM Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/cloud-solutions" className="nav-link">
                    Cloud Solutions
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/zohoservices" className="nav-link">
                    Zoho
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/developmentsupport" className="nav-link">
                    Development Support
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link">Portfolio</a>
              <ul className="sub-menu">
                <li className="sub-item">
                  <Link to="/web-portfolio" className="nav-link">
                    Web Portfolio
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/app-portfolio" className="nav-link">
                    App Portfolio
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link to="/blog" className="nav-link">
                Blog
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">
                Contact
              </Link>
            </li>
          </ul>
          <button href="#" id="get-quote-btn" className="btn btn-orange" onClick={() => window.openQuotePopup?.()}>
            Get a Quote
          </button>
        </div>
        <div className="mobile-menu" id="mobileMenu">
          <div className="mobile-logo">
            <Link to="/" className="navbar-brand d-flex align-items-center">
              <span className="logo-circles">
                <span className="circle circle-h">H</span>
                <span className="circle circle-w">W</span>
                <span className="circle circle-s">S</span>
              </span>
            </Link>
          </div>
          <button className="close-btn" id="closeMobileMenu">
            &times;
          </button>
          <ul className="mobile-nav">
            <li>
              <Link to="/about">About</Link>
            </li>
            <li className="mobile-sub-menu">
              <a href="#services" className="our-services-text-link" onClick={handleServicesClick}>
                Our Services
              </a>
              <ul className="sub-menu">
                <li className="sub-item">
                  <Link to="/web-development" className="nav-link">
                    Web Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/mobile-app-development" className="nav-link">
                    Mobile App Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/uiux" className="nav-link">
                    UI/UX Design
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/api-development" className="nav-link">
                    API Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/e-commerce-development" className="nav-link">
                    E-Commerce Development{" "}
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/crm-development" className="nav-link">
                    CRM Development
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/cloud-solutions" className="nav-link">
                    Cloud Solutions
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/zohoservices" className="nav-link">
                    Zoho
                  </Link>
                </li>
                <li className="sub-item">
                  <Link to="/developmentsupport" className="nav-link">
                    Development Support
                  </Link>
                </li>
              </ul>
            </li>
            <li className="mobile-sub-menu">
              <a className="our-text">
                Portfolio <i className="dropdown-icon">▼</i>
              </a>
              <ul className="sub-menu">
                <li className="sub-item">
                  <a href="web portfolio.html">Web Portfolio</a>
                </li>
                <li className="sub-item">
                  <a href="app-portfolio.html">App Portfolio</a>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <a
                href="#"
                id="get-quote-btn"
                className="btn btn-orange w-100 mt-3"
                onClick={() => {
                  window.openQuotePopup?.();
                  // Close mobile menu if open
                  const mobileMenu = document.getElementById("mobileMenu");
                  const overlay = document.getElementById("menuOverlay");
                  mobileMenu?.classList.remove("open");
                  overlay?.classList.remove("active");
                }}
              >
                Get a Quote
              </a>
            </li>
          </ul>
        </div>
        <div className="overlay" id="menuOverlay"></div>
      </div>
    </nav>
  );
};

export default Header;
